import { render, staticRenderFns } from "./technical.vue?vue&type=template&id=78c26472&"
import script from "./technical.vue?vue&type=script&lang=js&"
export * from "./technical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports